<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <!--<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
        {{collapsed?'':sysName}}
      </el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>-->
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
        <span style="cursor: pointer">
          {{collapsed?'':sysName}}
        </span>
        <i @click.prevent="collapse" class="tools fa fa-bars"></i>
      </el-col>
      <!--<el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>-->
      <div class="userinfo">
        <div class="header-card">
          <p>
            <img src="../assets/head.png" alt="">
            <span>{{sysUserName}}</span>
          </p>
        </div>
        <div class="header-card" @click="toHomepage()">
          <p>
            <img src="../assets/icon-homepage-cur.png" alt="">
            <span>返回首页</span>
          </p>
        </div>
        <div class="header-card" @click="downloadQr()" v-if="user.userType === 2">
          <p>
            <img src="../assets/icon-code.png" alt="">
            <span>下载二维码</span>
          </p>
        </div>
        <div class="header-card" @click="toMsg()">
          <p>
            <el-badge :value="messageCount" :max="99">
              <img src="../assets/icon-msg.png" alt="">
              <span>消息</span>
            </el-badge>
          </p>
        </div>
        <div class="header-card">
          <el-tooltip placement="bottom" effect="light">
            <div style="width: 500px;" slot="content">
              <el-calendar v-model="value">
              </el-calendar>
            </div>
            <p>
              <img src="../assets/icon-calendar.png" alt="">
              <span>日历</span>
            </p>
          </el-tooltip>
        </div>
        <div class="header-card" @click="handleFullScreen">
          <p>
            <img src="../assets/icon-expand.png" alt="">
            <span v-if="!fullscreen">全屏</span>
            <span v-else>取消全屏</span>
          </p>
        </div>
        <div class="header-card" @click="logout">
          <el-tooltip effect="light" content="退出登录" placement="bottom">
            <p>
              <img src="../assets/icon-sign-out.png" alt="">
              <span>退出</span>
            </p>
          </el-tooltip>
        </div>
        <!--<div class="header-card">
          <iframe class="iframe" name="weather_inc" src="http://i.tianqi.com/index.php?c=code&id=99&site=16&py=jinhua" width="160" height="36" frameborder="0" marginwidth="0" marginheight="0" scrolling="no"></iframe>
        </div>-->
      </div>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-未折叠-->
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo el-menu1" @open="handleopen" @close="handleclose"
                 @select="handleselect"
                 unique-opened router v-if="!collapsed">
          <template v-for="(item,index) in routes">
            <el-menu-item v-if="item.leaf&&item.children.length>0" :key="index" :index="item.children[0].path">
              <div>
                <i :class="item.iconCls"></i>{{item.children[0].name}}
              </div>
            </el-menu-item>
            <el-submenu v-else :index="index+''" :key="item.name">
              <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
              <template v-for="child in routeChildren(item)">
                <template v-if="'children' in child">
                  <el-submenu :index="child.path" :key="child.path">
                    <template slot="title">
                      <div style="padding-left: 6px">
                        <i :class="child.iconCls"></i>{{child.name}}
                      </div>
                    </template>
                    <el-menu-item v-for="child2 in routeChildren(child)" :index="child2.path" :key="child2.path">
                      <div style="padding-left: 10px">
                        {{child2.name}}
                      </div>
                    </el-menu-item>
                  </el-submenu>
                </template>
                <el-menu-item v-else :index="child.path" :key="child.path">
                  <div>
                    {{child.name}}
                  </div>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
        <ul class="el-menu el-menu-vertical-demo collapsed" v-else ref="menuCollapsed">
          <li v-for="(item,index) in menuList" :key="index" class="el-submenu item">
            <template v-if="item.leaf&&item.children.length>0">
              <div class="el-submenu__title el-menu-item"
                   style="height: 66px; line-height: 66px; padding: 0; text-align: center"
                   :class="$route.path===item.children[0].path?'is-active':''"
                   @click="$router.push(item.children[0].path)"><i style="width: auto;margin: 0;font-size: 20px" :class="item.iconCls"></i>
              </div>
            </template>
            <template v-else>
              <!--经过菜单显示对应ul的事件-->
              <div class="el-submenu__title" style="height: 66px; line-height: 66px; padding: 0; text-align: center" @mouseover="showMenu(index,true)"
                   @mouseout="showMenu(index,false)"><i style="width: auto;margin: 0;font-size: 20px" :class="item.iconCls"></i></div>
              <ul style="background-image: linear-gradient(90deg, rgba(156,202,244,0.9) 0%,rgba(55,159,223,0.9) 100%);" class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                  @mouseout="showMenu(index,false)">
                <template v-for="(child,index2) in item.children">
                  <li v-if="'children' in child" :key="child.path" class="el-submenu el-menu-item"
                      :class="$route.path===child.path?'is-active':''"
                      @mouseover="showMenu2(index2,true)" @mouseout="showMenu2(index2,false)">
                    {{child.name}}
                    <ul style="background-image: linear-gradient(90deg, rgba(156,202,244,0.9) 0%,rgba(55,159,223,0.9) 100%);" class="el-menu submenu2" :class="'submenu-hook2-'+index2" @mouseover="showMenu2(index2,true)"
                        @mouseout="showMenu2(index2,false)">
                      <li v-for="child2 in child.children" :key="child2.path" class="el-submenu el-menu-item"
                        :class="$route.path===child2.path?'is-active':''"
                        @click="$router.push(child2.path)">
                      {{child2.name}}
                      </li>
                    </ul>
                  </li>
                  <li v-else :key="child.path" class="el-submenu el-menu-item"
                      :class="$route.path===child.path?'is-active':''"
                      @click="$router.push(child.path)">
                    {{child.name}}
                  </li>
                </template>
              </ul>
            </template>
          </li>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content">
          <el-col v-if='$route.path != "/homepage"' :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { doPost, websocketUrl, base } from '../api/api'
import { resetRouter, baseRoutes, formatMenuToRouter } from '../routes'
export default {
  data () {
    return {
      user: {},
      sysName: '快出租',
      collapsed: false,
      sysUserName: '管理员',
      sysUserAvatar: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      fullscreen: false,
      menuList: [],
      messageCount: 0,
      notifyArray: [],
      value: new Date()
    }
  },
  computed: {
    // 关于v-for v-if，data里未定义的变量遍历使用计算属性。否则使用v-for v-if配合使用
    routes: function () {
      return this.menuList.filter(function (item) {
        return !item.hidden
      })
    },
    // 利用闭包实现计算属性传参。
    routeChildren: function (route) {
      return function (route) {
        if (route.children) {
          return route.children.filter(function (child) {
            return !child.hidden
          })
        }
      }
    }
  },
  methods: {
    downloadQr () {
      if (this.user.userType === 2) {
        window.location.href = base + '/companies/getQrByCode?unifiedCode=' + this.user.userName
      }
    },
    onSubmit () {
      console.log('submit!')
    },
    handleopen (obj) {
      if (this.routes[obj].name === '初信初访办理') {
        // 展开初信初访办理默认跳转初信初访概述
        this.$router.push('/cxcfhome')
      }
    },
    handleclose () {
      // console.log('handleclose');
    },
    handleselect: function (a, b) {
    },
    // 退出登录
    logout: function () {
      var _this = this
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('menuList')
        _this.$router.push('/login')
      }).catch(() => {

      })
    },
    // 折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed
    },
    showMenu (i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none'
    },
    showMenu2 (i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook2-' + i)[0].style.display = status ? 'block' : 'none'
    },
    initMenu () {
      var menuList = sessionStorage.getItem('menuList')
      if (menuList) {
        console.log('加载已有菜单')
        // 已存在路由 在onReady方法中已加载
        var menuObj = JSON.parse(menuList)
        // console.log(menuObj)
        var userRoutes = formatMenuToRouter(menuObj)
        // 初始化菜单
        this.menuList = []
        this.menuList = this.menuList.concat(baseRoutes)
        this.menuList = this.menuList.concat(userRoutes)
      } else {
        console.log('重新获取菜单')
        var para = {
          userId: this.user.id
        }
        doPost('/sysMenu/getSysMenuTree', para).then(data => {
          console.log(data.result)
          var userRoutes = formatMenuToRouter(data.result)
          // 重置路由
          resetRouter()
          // 初始化菜单
          this.menuList = []
          this.menuList = this.menuList.concat(baseRoutes)
          this.menuList = this.menuList.concat(userRoutes)
          this.$router.addRoutes(userRoutes)
          sessionStorage.setItem('menuList', JSON.stringify(data.result))
        })
      }
    },
    initMessage () {
      var para = { toUserId: this.user.id }
      doPost('/message/getUnReadMsgCount', para).then((res) => {
        console.log('消息数量==》' + res.result)
        this.messageCount = res.result
      })
    },
    initWebsocket () {
      // 判断当前浏览器是否支持WebSocket
      if ('WebSocket' in window) {
        var fullUrl = websocketUrl + this.user.id
        console.log('全路径==》' + fullUrl)
        this.websocket = new WebSocket(fullUrl)
      } else {
        console.log('当前浏览器不支持：websocket')
      }
      // 连接发生错误的回调方法
      this.websocket.onerror = this.websocketOnError
      // 连接成功建立的回调方法
      this.websocket.onopen = this.websocketOnOpen
      // 接收到消息的回调方法
      this.websocket.onmessage = this.websocketOnMessage
      // 连接关闭的回调方法
      this.websocket.onclose = this.websocketOnClose

      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      this.websocket.onbeforeunload = this.websocketOnbeforeunload
    },
    // 连接发生错误的回调方法
    websocketOnError (err) {
      console.log('WebSocket 连接发生错误')
      console.log(err)
    },
    websocketOnOpen () {
      console.log('WebSocket连接成功')
    },
    // 接收到消息的回调方法
    websocketOnMessage (event) {
      // 接收消息
      var obj = JSON.parse(event.data)
      console.log('接收到消息')
      this.initMessage()
      this.openNotification(obj.messageTitle, '有一条新消息提醒!', obj.messageUserId)
      //        if(obj.messageType == 103 || obj.messageType == 104){
      //          //websocket推送回来 下单声音提示
      //          this.aplayAudio();
      //        }
    },
    // 连接关闭的回调方法
    websocketOnClose (e) {
      console.log('WebSocket 连接关闭', e)
    },
    // 关闭 WebSocket 连接
    websocketOnbeforeunload () {
      // 关闭连接
      this.websocket.close()
    },
    openNotification (title, content, messageUserId) {
      const h = this.$createElement
      var notify = this.$notify({
        title: title,
        message: h('p', [
          h('p', null, content),
          h('p', {
            style: 'text-align: right;width:195px;dispaly:block;margin-top: 8px;color:#43c39d',
            on: {
              click: () => {
                this.toViewInfo(messageUserId)
              }
            }
          }, '查看')
        ]),
        duration: 10000
      })
      notify.key = messageUserId
      this.notifyArray.push(notify)
    },
    toViewInfo (messageUserId) {
      //      alert("点击消息"+messageUserId)
      var para = { messageUserId: messageUserId }
      doPost('/message/readMessage', para).then((res) => {
        this.initMessage()
        // 关闭对应弹框消息
        for (var i = 0; i < this.notifyArray.length; i++) {
          var notify = this.notifyArray[i]
          if (notify.key === messageUserId) {
            notify.close()
          }
        }
        console.log(res.result)
        if (res.result.pushMessage != null && res.result.pushMessage.messageKey != null) {
          // 打开消息关联的地址页
          this.$router.push({
            path: res.result.viewUrl,
            query: {
              messageKey: res.result.pushMessage.messageKey,
              keepAlive: false
            }
          })
        }
      })
    },
    handleFullScreen () {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    toHomepage () {
      // this.$router.push('/homepage')
      var firstPath = sessionStorage.getItem('firstPath')
      this.$router.push(firstPath)
    },
    toMsg () {
      this.$router.push('/message')
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    console.log(this.user)
    this.sysUserName = this.user.realName || this.user.userName
    if (this.user.userQualifi != null) {
      this.sysUserName += '(' + this.user.userQualifi.name + ')'
    }
    this.sysUserAvatar = this.user.avatar || ''
    this.initMenu()
    this.initMessage()
    this.initWebsocket()
  }
}

</script>
<style lang="scss">
  @import '../styles/vars';

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;

    .header {
      height: 60px;
      line-height: 60px;
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,.1);
      position: relative;
      z-index: 1000;
      .userinfo {
        text-align: right;
        padding-right: 25px;
        float: right;

        .userinfo-inner {
          cursor: pointer;

          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
        }
      }

      .logo {
        background-color: #1E8BD0;
        color: #fff;
        height: 60px;
        font-size: 18px;
        padding-left: 20px;
        padding-right: 20px;

        img {
          width: 40px;
          float: left;
          margin: 10px 10px 10px 18px;
        }

        .txt {
          color: #fff;
        }
      }

      .logo-width {
        width: 250px;
        transition: all 0.3s;
      }

      .logo-collapse-width {
        width: 60px;
        transition: all 0.3s;
      }

      .tools {
        height: 60px;
        line-height: 60px;
        padding-right: 2px;
        float: right;
        cursor: pointer;
      }
    }

    .main {
      display: flex;
      position: absolute;
      top: 60px;
      bottom: 0px;
      overflow: hidden;

      aside {
        flex: 0 0 250px;
        width: 250px;
        .el-menu {
          height: 100%;
        }

        .collapsed {
          width: 60px;

          .item {
            position: relative;
          }

          .submenu {
            position: absolute;
            top: 0;
            left: 60px;
            z-index: 99999;
            height: auto;
            display: none;
          }
          .submenu2 {
            position: absolute;
            top: 0;
            left: 100%;
            z-index: 99999;
            height: auto;
            display: none;
          }

        }
      }

      .menu-collapsed {
        flex: 0 0 60px;
        width: 60px;
      }

      .menu-expanded {
        flex: 0 0 250px;
        width: 250px;
        background-image: url("../assets/img-main-bg.png");
        background-size: 100% 100%;
        /*background-image: linear-gradient(0deg, #3048bf 0%,#5c8ae5 30%,#003366 100%);*/

        .el-menu { /*打补丁的方式解决左侧菜单宽度显示不全*/
          width: 100% !important;
        }

        .el-submenu .el-menu-item {
          min-width: 0px !important;
          padding-left: 56px !important;
          color: #fff;
        }

        .el-submenu .el-menu-item.is-active {
          /*color: #fff;*/
        }
      }

      .content-container {
        flex: 1;
        overflow-y: auto;
        background-color: #f7f7f7;

        .breadcrumb-container {
          background-color: #fff;
          padding: 20px;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          .title {
            width: 200px;
            float: left;
            color: #475669;
          }

          .breadcrumb-inner {
            float: right;
          }
        }

        .content-wrapper {
          background-color: #f7f7f7;
          padding: 20px;
          box-sizing: border-box;
        }
      }
    }
  }
  .menu-collapsed {
    border-right: solid 1px #e6e6e6;
    transition: all 0.3s;
    background-image: url("../assets/img-main-bg.png");
    background-size: auto 100%;
    background-position: center;
    /*background-image: linear-gradient(0deg, #3048bf 0%,#5c8ae5 30%,#003366 100%);*/
  }
  .menu-expanded {
    border-right: solid 1px #e6e6e6;
    transition: all 0.3s;
  }
  .el-menu {
    border-right: none;
    background: none;
    color: #fff;
  }
  .el-menu1 {
    overflow-y: auto;
  }
  .el-menu::-webkit-scrollbar { width: 0 !important }
  .el-menu {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
  .el-submenu__title,.el-submenu__title i {
    color: #fff;
  }
  .el-submenu [class^=fa] {
    width: 16px;
    text-align: center;
  }
  .el-menu-item {
    min-width: 0px !important;
  }

  .el-menu-item {
    color: #fff;
    i {
      color: #fff;
    }
  }

  .el-menu-item:focus, .el-menu-item:hover {
    background-color: #58c0ec!important;
    color: #fff!important;
    i {
      color: #fff;
    }
  }
  .el-submenu__title:hover {
    background-color: #58c0ec!important;
    color: #fff!important;
    i {
      color: #fff;
    }
  }
  .el-menu-item.is-active {
    background-color: #58c0ec!important;
    color: #fff!important;
    i {
      color: #fff;
    }
  }
  /*.el-menu .el-menu-item.is-active {
    background-color: rgba(255,255,255,0.1);
    color: #fff;
  }
  .el-menu-item:focus, .el-menu-item:hover {
    color: #fff!important;
    background-color: rgba(255,255,255,0.1);
  }
  .el-submenu__title:focus, .el-submenu__title:hover {
    color: #fff;
    background-color: rgba(255,255,255,0.1);
  }
  .is-active>.el-submenu__title,.is-active i {
    color: #fff;
  }
  .el-menu-item {
    color: #dbdbdb;
    i {
      color: #dbdbdb;
    }
  }*/
  .search {
    margin-left: 20px;
    width: 220px;
  }
  .search .el-input__inner {
    border: none;
    padding-left: 35px;
  }
  .search .el-input__icon {
    font-size: 18px;
  }
  .header-card {
    height: 60px;
    line-height: 60px;
    float: left;
    margin-left: 50px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .header-card p {
    text-align: center;
  }
  .header-card img {
    display: block;
    width: 22px;
    height: 22px;
    margin: 0 auto;
  }
  .header-card span {
    display: block;
    font-size: 12px;
    line-height: 20px;
  }
  .el-calendar-table .el-calendar-day {
    height: 45px;
  }

</style>
